import { defineComponent as _defineComponent } from 'vue'
import LoanApplication from '@/models/LoanApplication';
import LoanApplicationStatusChip from '@/components/commons/LoanApplicationStatusChip.vue';
import {computed, onMounted, ref} from 'vue';
import RaiffeisenApi from '@/modules/raiffeisen/services/RaiffeisenApi';
import { RaiffeisenApplicationStatus, RaiffeisenLeadStatusData } from '@/models/integrations/RaiffeisenLoanApplication';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import LChip from '@/components/commons/LChip.vue';
import { groupBy } from 'lodash-es';
import { trimString } from '@/composables/useFilters';


export default /*#__PURE__*/_defineComponent({
  __name: 'VListLoanApplication',
  props: {
    loanApplications: null,
    showStatus: { type: Boolean, default: false },
    reportedApplicationId: { default: null },
    tilePadding: { default: '0px' },
    small: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { loanApplications: LoanApplication[], showStatus: boolean, reportedApplicationId: Nullable<number>, tilePadding: string, small: boolean };



const raiffeisenLeadStatus = ref<RaiffeisenLeadStatusData[]>([]);

const reportedApplication = computed<Nullable<number>>(
  () => props.loanApplications && props.reportedApplicationId
    ? props.loanApplications.findIndex(e => e.id === props.reportedApplicationId)
    : null
);

const getName = (loanApplication: LoanApplication): string => loanApplication.productName || loanApplication.name;

const backgroundColor = (loanApplication: LoanApplication, index?: number): string => {
  if (!loanApplication.isLoanApplicationAvailable) {
    return 'rgba(35, 45, 59, 0.02)';
  }
  return index === reportedApplication.value ? 'var(--token-success-surface)' : 'initial';
};

onMounted(async() => {
  for (const loanApplication of props.loanApplications) {
    const leadId = loanApplication.raiffeisenLead?.response?.leadId;
    if (loanApplication.isProcessIntegration && leadId) {
      raiffeisenLeadStatus.value = (await RaiffeisenApi.getRaiffeisenLeadStatus(leadId))?.data || [];
    }
  }
});

const getRaiffeisenApplicationStatusColor = (status: RaiffeisenApplicationStatus): string => {
  switch (status) {
    case RaiffeisenApplicationStatus.DISBURSED:
      return 'success';
    case RaiffeisenApplicationStatus.CANCELLED:
    case RaiffeisenApplicationStatus.REJECTED:
      return 'error';
    default:
      return 'primary';
  }
};

const raiffeisenApplicationStatuses = computed<Record<string, Array<RaiffeisenLeadStatusData>>>(() => {
  return groupBy(raiffeisenLeadStatus.value, 'leadId');
});

const raiffeisenApplicationStatus = computed<Record<string, {name: string, color: string}>>(() => {
  return Object.keys(raiffeisenApplicationStatuses.value).reduce((acc, key) => {
    acc[key] = {
      name: I18NGetter().RaiffeisenApplicationStatus[raiffeisenApplicationStatuses.value[key][0].applicationStatus],
      color: getRaiffeisenApplicationStatusColor(raiffeisenApplicationStatuses.value[key][0].applicationStatus),
    };
    return acc;
  }, {} as Record<string, {name: string, color: string}>);
});

return { __sfc: true,props, raiffeisenLeadStatus, reportedApplication, getName, backgroundColor, getRaiffeisenApplicationStatusColor, raiffeisenApplicationStatuses, raiffeisenApplicationStatus, LoanApplicationStatusChip, LChip, trimString }
}

})